import api from 'services/api';

export async function logout() {
  const response = await api.delete('/api/auth/logout');

  return response;
}
